export default {
  form: {
    address: {
      delivery: {
        placeholder: 'Cerca il tuo indirizzo di consegna',
      },
      placeholder: 'Inserisci un indirizzo per trovare la sede più vicina',
    },
  },
  toasts: {
    failed_to_load_stores: 'Impossibile caricare i negozi, aggiorna la pagina',
  },
  errors: {
    no_delivery_companies: 'Consegna non disponibile per questo indirizzo',
    delivery_not_available: 'Purtroppo al momento non offriamo la consegna',
    location_unavailable:
      "Impossibile accedere alla tua posizione, abilita i permessi o inserisci l'indirizzo manualmente",
    location_lookup_failed: 'Impossibile trovare il tuo indirizzo, riprova',
    address_suggestions_unavailable: 'Impossibile caricare i suggerimenti di indirizzo.',
  },
  buttons: {
    use_current_location: 'Usa la mia posizione attuale',
    locating: 'Ricerca della posizione in corso…',
    retry: 'Riprova',
  },
};
